import { Component, OnInit, ViewChild, Inject } from '@angular/core';
import { WriteReviewService } from '../shared/service/write-review.service';
import { MatPaginator, MatSort, MatTableDataSource } from '@angular/material';
import { Router } from '@angular/router';
const LOCAL_USER_KEY = "UserName";
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { CommonService } from '../shared/service/common.service';
import { Review } from '../shared/model/Review';
import { StarRatingComponent } from 'ng-starrating';

@Component({
  selector: 'app-admin-review',
  templateUrl: './admin-review.component.html',
  styleUrls: ['./admin-review.component.css']
})
export class AdminReviewComponent implements OnInit {
  @BlockUI() blockUI: NgBlockUI;
  LocalToken: string = '';
  dataSource: any;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  displayedColumns: string[] = ['TourName', 'OneWordReview', 'ReviewDescription', 'Name', 'Mobile', 'RateValue', 'Edit', 'Delete'];
  reviewArr: any = [];

  constructor(private writeReviewService: WriteReviewService, private router: Router, private dialog: MatDialog) { }

  ngOnInit() {
    this.LocalToken = localStorage.getItem(LOCAL_USER_KEY);
    if (this.LocalToken != null) {
      this.getReviews();
    }
    else {
      this.router.navigate(["admin/logIn"]);
    }
  }

  getReviews() {
    this.writeReviewService.getAllReview().then((result) => {
      console.log("result of review", result);
      this.reviewArr = result;
      this.dataSource = new MatTableDataSource(this.reviewArr);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
    })
      .catch((err) => console.log(err))
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  editReview(reviewObj) {
    const dialogRef = this.dialog.open(EditReviewDialog, {
      width: '1000px',
      data: JSON.parse(JSON.stringify(reviewObj))
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getReviews();
    });
  }

  deleteReview(ID) {
    if (this.reviewArr.length > 1) {
      if (confirm('Are you sure you want selected item deleted !')) {
        this.writeReviewService
          .deleteReviewByID(ID)
          .then((result) => this.getReviews())
          .catch((err) => console.log(err));
      }
    }
  }

}

// Dialoag Component

@Component({
  selector: 'edit-review-dialog',
  templateUrl: 'edit-review-dialog.html',
})
export class EditReviewDialog {
  @BlockUI() blockUI: NgBlockUI;
  isUpdate: boolean = false;

  constructor(
    public dialogRef: MatDialogRef<EditReviewDialog>,
    @Inject(MAT_DIALOG_DATA) public data: Review, private writeReviewService: WriteReviewService, private commonService: CommonService) {
    if (this.data.Id) {
      console.log("Item: ", this.data)
      this.isUpdate = true;
    }
    else {
      this.isUpdate = false;
    }
  }

  onRate($event: { oldValue: number, newValue: number, starRating: StarRatingComponent }) {
    // alert(`Old Value:${$event.oldValue}, 
    //   New Value: ${$event.newValue}, 
    //   Checked Color: ${$event.starRating.checkedcolor}, 
    //   Unchecked Color: ${$event.starRating.uncheckedcolor}`);
    this.data.RateValue = $event.newValue;
  }

  editReview() {
    this.blockUI.start('Please wait...');
    console.log("data", this.data);
    this.writeReviewService
      .editReview(this.data)
      .then((result) => {
        this.clearControl();
        this.blockUI.stop();
        this.dialogRef.close(this.data);
      })
      .catch((err) => this.errorHandler(err));
  }

  clearControl() {
    this.data
  }

  errorHandler(err: any) {
    console.log(err);
    this.blockUI.stop();
  }
}
